export default "__VITE_ASSET__DCY3iiZr__"